
import React, { Component, Fragment } from 'react';
import { InputField } from './InputField';

export class InputFieldArray extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        let { formState, onUpdate } = this.props;

        return (
            <Fragment>
                {formState?.Fields.map((f, k) =>
                    <InputField
                        label={f.FieldLabel}
                        fieldname={f.FieldName}
                        key={f.FieldName}
                        regularExpression={f.Validation}
                        warnText='Invalid format'
                        fieldType={f.FieldType}
                        mandatory={f.IsMandatory}
                        value={f.Value}
                        onUpdate={onUpdate.bind(this)}
                        fieldValid={f.IsValid}
                        prependWidth={'200px'}
                        description={f.Description}
                    />

                )}
            </Fragment>
        );
    }
}